<template>
  <div class="site-approval-container">
    <Condition ref="condition" :onSearch="onSearch" :loading="loading" :classList="classList" />

    <div class="site-appreval-tab-container">
      <TableHeadIcons
        style="position: relative"
        :onRefresh="() => onSearch()"
        :size.sync="tableDensity"
        :columns="columns"
      >
        <div
          v-for="(tab, index) in tabList"
          :key="index"
          class="tab"
          :class="{ active: activeTabIndex === index }"
          @click="onSelectTab(index)"
        >
          {{ tab.label }}
        </div>

        <a-dropdown
          v-if="activeTabIndex === 0"
          :disabled="!selectedRowKeys.length > 0"
          type="primary"
          style="margin-left: 10px"
        >
          <a-button type="primary"> 批量操作 <a-icon type="down" /> </a-button>
          <a-menu slot="overlay">
            <a-menu-item key="download-zip" style="margin-left: 10px" @click="handApprovalBatch(1)">
              通过
            </a-menu-item>
            <a-menu-item key="download-rar" style="margin-left: 10px" @click="handApprovalBatch(2)">
              驳回
            </a-menu-item>
            <a-menu-item
              key="download-html"
              style="margin-left: 10px"
              @click="handApprovalBatch(3)"
            >
              删除
            </a-menu-item>
          </a-menu>
        </a-dropdown>

        <a-button
          v-else
          type="primary"
          :disabled="!selectedRowKeys.length > 0"
          @click="activeTabIndex !== 3 ? handApprovalBatch(3) : handApprovalDel()"
        >
          批量删除
        </a-button>
      </TableHeadIcons>

      <a-table
        :size="tableDensity"
        :loading="loading"
        :pagination="pagination"
        @change="handleTableChange"
        rowKey="spiderId"
        :columns="showColumns"
        :data-source="tableData"
        :row-selection="{
          type: 'checkbox',
          onChange: onSelectChang,
          selectedRowKeys: selectedRowKeys
        }"
      >
        <span slot="index" slot-scope="text, record, index">{{ index + 1 }}</span>

        <span slot="spiderId" slot-scope="text, record, index">
          <a-tooltip>
            <template slot="title"> {{ record.spiderId }} </template>
            <span>
              {{ record.spiderId }}
            </span>
          </a-tooltip>

          <a-tooltip>
            <template slot="title"> 复制 </template>
            <a
              href="javascript:;"
              v-clipboard:copy="text"
              v-clipboard:success="onCopy"
              v-clipboard:error="onCopyError"
            >
              <a-icon type="copy" />
            </a>
          </a-tooltip>
        </span>

        <span slot="spiderName" slot-scope="text, record, index">
          <a-tooltip>
            <template slot="title"> {{ record.spiderName }} </template>
            <span>
              {{ record.spiderName }}
            </span>
          </a-tooltip>

          <a-tooltip>
            <template slot="title"> 复制 </template>
            <a
              href="javascript:;"
              v-clipboard:copy="text"
              v-clipboard:success="onCopy"
              v-clipboard:error="onCopyError"
            >
              <a-icon type="copy" />
            </a>
          </a-tooltip>
        </span>

        <span slot="spiderClassId" slot-scope="text, record, index">{{ findClassName(text) }}</span>

        <span slot="action" slot-scope="text, record">
          <template v-if="activeTabIndex === 0">
            <a-popconfirm title="确定要通过吗?" @confirm="() => changeStatus(record, 1)">
              <a> 通过 </a>
            </a-popconfirm>
            <a-divider type="vertical" />
            <a-popconfirm title="确定要驳回吗?" @confirm="() => changeStatus(record, 2)">
              <a> 驳回 </a>
            </a-popconfirm>

            <a-divider type="vertical" />
            <router-link
              :to="{
                name: 'site_create_form',
                query: {
                  spiderId: record.spiderId,
                  type: findClassType(record.spiderClassId),
                  route: 'site_approval'
                }
              }"
            >
              <a> 编辑 </a>
            </router-link>
            <a-divider type="vertical" />
          </template>

          <a-popconfirm
            title="确定要删除吗?"
            @confirm="() => (activeTabIndex === 3 ? onDelete(record) : changeStatus(record, 3))"
          >
            <a> 删除 </a>
          </a-popconfirm>
        </span>
      </a-table>
    </div>
  </div>
</template>

<script>
const All_Types = ['news', 'api', 'document', 'wechat']
import Condition from './Condition'
import { toBeReviewedColumns, reviewedColumns, rejectColumns, deletedColumns } from './columns'
import {
  getApprovalListIdApi,
  changeSiteStatusApi,
  deleteSiteApi,
  handApprovalBatchApi,
  delApprovalBatchApi
} from '@/api/Site/Approval'
import { querySpiderClassInfoApi } from '@/api/Site/Type'

export default {
  components: { Condition },

  data() {
    return {
      conditionStorage: {},
      tableDensity: 'middle',

      activeTabIndex: 0,
      tabList: [
        {
          label: '待审核',
          columns: toBeReviewedColumns,
          examineStatus: 0
        },
        {
          label: '已通过',
          columns: reviewedColumns,
          examineStatus: 1
        },
        {
          label: '已驳回',
          columns: rejectColumns,
          examineStatus: 2
        },
        {
          label: '已删除',
          columns: deletedColumns,
          examineStatus: 3
        }
      ],
      loading: false,

      pagination: {
        current: 1,
        pageSize: 10,
        showTotal: (total) => `共 ${total} 条`,
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        size: 'default'
      },

      tableData: [],
      classList: [],

      selectedRowKeys: []
    }
  },

  computed: {
    columns() {
      return this.tabList[this.activeTabIndex].columns
    },

    showColumns() {
      return this.columns.filter((item) => item.show)
    }
  },

  mounted() {
    this.getSpiderClassInfo()
  },

  methods: {
    // 复制成功时的回调函数
    onCopy(e) {
      this.$message.success('已复制')
    },
    // 复制失败时的回调函数
    onCopyError(e) {
      this.$message.error('复制失败')
    },
    copy: function () {
      var _this = this
      var clipboard = new Clipboard('#copy_text')

      clipboard.on('success', (e) => {
        message.success('复制成功')
        // 释放内存
        clipboard.destroy()
      })
      clipboard.on('error', (e) => {
        // 不支持复制
        Message({
          message: '该浏览器不支持自动复制',
          type: 'warning'
        })
        // 释放内存
        clipboard.destroy()
      })
    },

    async getTableData() {
      if (!this.conditionStorage.spiderClassId) {
        this.$message.error('请选择站点类型')
        return
      }
      this.loading = true
      const query = {
        ...this.conditionStorage,
        examineStatus: this.tabList[this.activeTabIndex].examineStatus,
        pn: this.pagination.current,
        pageSize: this.pagination.pageSize
      }

      const { code, data, msg, extra } = await getApprovalListIdApi(query)

      if (code === 200) {
        this.tableData = this.formatNewsTableData(data)
        this.pagination.total = extra.page.pageCount || 0
      } else {
        this.$message.error(msg)
      }

      this.loading = false
    },

    onSearch(condition) {
      if (condition) {
        this.conditionStorage = { ...condition }
      }
      this.pagination.current = 1
      this.getTableData()
    },

    onSelectTab(index) {
      this.activeTabIndex = index
      this.onSearch()
    },

    onSelectChang(selectedRowKeys) {
      this.selectedRowKeys = [...selectedRowKeys]
    },

    handleTableChange(pagination) {
      this.pagination = pagination
      this.getTableData()
    },

    formatNewsTableData(data) {
      return data.map((d) => {
        return {
          spiderId: d.spiderId,
          spiderName: d.spiderName,
          spiderClassId: d.spiderClassId,
          applyName: d.applyName,
          createTime: d.createTime,
          examineTime: d.examineTime,
          examineName: d.examineName
        }
      })
    },

    async getSpiderClassInfo() {
      let res = await querySpiderClassInfoApi()
      let { code, msg, data } = res
      if (code !== 200) {
        this.$message.error(msg)
        return
      }

      this.classList = data.filter((d) => All_Types.includes(d.type))
    },

    findClassName(id) {
      return this.classList.find((d) => d.spiderClassId === id)?.spiderClassName
    },

    findClassType(id) {
      return this.classList.find((d) => d.spiderClassId === id)?.type
    },

    async changeStatus(record, to) {
      const { code } = await changeSiteStatusApi({
        spiderId: record.spiderId,
        spiderClassId: record.spiderClassId,
        examineStatus: to
      })

      if (code !== 200) {
        this.$message.error(msg)
        return
      }

      this.$message.success('操作成功')

      this.getTableData()
    },

    async onDelete(record) {
      const { code, msg } = await deleteSiteApi(record)
      if (code !== 200) {
        this.$message.error(msg)
        return
      }

      this.$message.success('操作成功')
      this.getTableData()
    },

    async handApprovalBatch(status) {
      let params = []
      this.tableData.forEach((item) => {
        if (this.selectedRowKeys.includes(item.spiderId)) {
          params.push({
            spiderId: item.spiderId,
            spiderClassId: item.spiderClassId,
            examineStatus: status
          })
        }
      })
      const { code, msg } = await handApprovalBatchApi(params)
      if (code !== 200) {
        this.$message.error(msg)
        return
      }

      this.$message.success('操作成功')
      this.selectedRowKeys = []
      this.getTableData()
    },

    // 删除情况下的批量删除：
    async handApprovalDel() {
      let params = []
      this.tableData.forEach((item) => {
        if (this.selectedRowKeys.includes(item.spiderId)) {
          params.push({
            spiderId: item.spiderId,
            spiderClassId: item.spiderClassId
          })
        }
      })

      const { code, msg } = await delApprovalBatchApi(params)
      if (code !== 200) {
        this.$message.error(msg)
        return
      }

      this.$message.success('操作成功')
      this.getTableData()

      // const promises = params.map((item) => {
      //   return deleteSiteApi(item)
      // })

      // Promise.all(promises)
      //   .then((res) => {
      //     console.log(res)
      //     this.$message.success('操作成功')
      //     this.selectedRowKeys = []
      //     this.getTableData()
      //   })
      //   .catch((reason) => {
      //     console.log(reason)
      //   })
    }
  }
}
</script>

<style lang="less">
.site-approval-container {
  width: 100%;
  padding: 16px;
}

.site-appreval-tab-container {
  background: white;
  margin-top: 16px;
  padding: 0 16px;

  .tab {
    padding: 0 16px 12px;
    position: relative;
    cursor: pointer;
    font-size: 14px;

    &.active {
      &::after {
        content: '';
        position: absolute;
        left: 0;
        bottom: 0;
        right: 0;
        height: 2px;
        background: #0088ff;
      }
    }
  }

  .table-container {
    background: white;
    padding: 0 16px;
  }
}
</style>
